import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Stack, styled, Typography } from '@mui/material'
import type { FC } from 'react'
import { useNavigate } from 'react-router'

import type { BenefitsGroupDto } from '@hcr/api/optimizely'
import { COLORS, ICONS, unit } from '@hcr/ui'

import { Path } from '../../../../../../../../models/navigation'
import { to } from '../../../../../../../../utils/navigation'

interface BenefitPreviewProps {
  benefit: BenefitsGroupDto['content'][number]
}

export const BenefitPreview: FC<BenefitPreviewProps> = ({ benefit }) => {
  const navigate = useNavigate()

  return (
    <Wrapper>
      <Stack
        direction='row'
        gap={unit(6)}
        justifyContent='space-between'
        paddingY={unit(3.5)}
        sx={{ cursor: 'pointer' }}
        onClick={() => navigate(to([Path.OwnerBenefitDetails, { benefitId: String(benefit.benefitId) }]))}
      >
        <Stack direction='column'>
          <Typography variant='headlineExtraSmall' color={COLORS.burgundi[500]}>
            {benefit.title}
          </Typography>
          <Typography variant='labelM'>{benefit.subtitle}</Typography>
        </Stack>
        <IconWrapper>
          <FontAwesomeIcon size={'lg'} icon={ICONS.farChevronRight} />
        </IconWrapper>
      </Stack>
    </Wrapper>
  )
}

const Wrapper = styled(Box)`
  margin-left: ${unit(4)};
  margin-right: ${unit(4)};

  &:not(:last-child) {
    border-bottom: ${unit(0.25)} dashed ${COLORS.vaalea[800]};
  }
`

const IconWrapper = styled(Box)`
  padding-top: ${unit(1)};
  padding-rigth: ${unit(2)};
`
